import { uiRows } from './types-def.js';
/**
 * `web/sheets/pc` (2.H; CS r6c deliverable 205, DECISIONS 222 ruling 5), due at exit-2c: the PC
 * sheet of a player character's page.
 */
export const SHEETS_PC_INTERACTIONS = uiRows([
    {
        id: 'sheets.pc.open',
        module: 'web/sheets/pc',
        behavior: "The header's Character sheet pill opens the page's PC sheet",
        owner: '2.H',
        since: 'exit-2c',
    },
    {
        id: 'sheets.pc.edit',
        module: 'web/sheets/pc',
        behavior: "A value's pencil edits it in place and saves it as the GM's own",
        owner: '2.H',
        since: 'exit-2c',
    },
    {
        id: 'sheets.pc.revert',
        module: 'web/sheets/pc',
        behavior: "Revert puts an edited value back to Foundry's",
        owner: '2.H',
        since: 'exit-2c',
    },
    {
        id: 'sheets.pc.portrait',
        module: 'web/sheets/pc',
        behavior: "The portrait is the page's cover image, changed from the sheet",
        owner: '2.H',
        since: 'exit-2c',
    },
    {
        id: 'sheets.pc.labels',
        module: 'web/sheets/pc',
        behavior: 'Each derived value says whether Foundry or the app computed it, and shows when the two disagree',
        owner: '2.H',
        since: 'exit-2c',
    },
]);
//# sourceMappingURL=sheets-pc.js.map